import React from "react";

/**
 * Real product marks for the toolbar.
 *
 * A grey envelope beside "0/15 Gmail" makes people ask *which* mail — the logo
 * answers before the label is read. Same reasoning for Chrome wherever the row
 * reports a browser. These identify a third-party service, which is what a
 * product mark is for; everything TeamGrid owns keeps a line glyph instead.
 *
 * Drawn at 24 and scaled by `size`, so they sit on the same optical weight as
 * the lucide icons beside them.
 */
export function GmailMark({ size = 15 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path fill="#4285F4" d="M2 7.1v10.4A1.5 1.5 0 0 0 3.5 19H6.4V9.9L2 7.1z" />
      <path fill="#34A853" d="M17.6 19h2.9a1.5 1.5 0 0 0 1.5-1.5V7.1l-4.4 2.8V19z" />
      <path fill="#FBBC04" d="M22 5.9v1.2l-4.4 2.8V5.4l1.8-1.2c1.2-.8 2.6.1 2.6 1.7z" />
      <path fill="#EA4335" d="M2 5.9v1.2l4.4 2.8V5.4L4.6 4.2C3.4 3.4 2 4.3 2 5.9z" />
      <path fill="#C5221F" d="M6.4 5.4 12 9.1l5.6-3.7v4.5L12 13.6 6.4 9.9V5.4z" />
    </svg>
  );
}

export function ChromeMark({ size = 15 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <circle cx="12" cy="12" r="10" fill="#fff" />
      <path fill="#EA4335" d="M12 2a10 10 0 0 1 8.66 5H12a5 5 0 0 0-4.33 2.5L3.9 4.9A9.98 9.98 0 0 1 12 2z" />
      <path fill="#FBBC04" d="M3.9 4.9 7.67 9.5A5 5 0 0 0 7 12a5 5 0 0 0 2.1 4.07l-2.6 4.3A10 10 0 0 1 3.9 4.9z" />
      <path fill="#34A853" d="M20.66 7A10 10 0 0 1 6.5 20.37l4.1-6.8A5 5 0 0 0 17 12a5 5 0 0 0-.72-2.58L20.66 7z" />
      <circle cx="12" cy="12" r="4" fill="#4285F4" />
    </svg>
  );
}
